var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-header blueHeader",
      style: _vm.cardHeaderBackgroundColor,
      on: {
        click: function ($event) {
          return _vm.hideBlock($event)
        },
      },
    },
    [
      _vm._v("\n  " + _vm._s(_vm.$t(_vm.label)) + "\n  "),
      _c("i", { staticClass: "fa-light fa-chevron-right" }, [
        _vm._v("chevron_right"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }